import { Checkbox, Radio } from '@arionbanki/arionui';
import { buildAnswer, classNames as cn } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';
import { addAnswer, removeAnswer, removeAnswers } from 'store/actions';
import { type ChoiceProps, QuestionType } from 'types';
import { QuestionLabel } from './Labels';

export function Choice(props: ChoiceProps & { questionType: QuestionType }) {
	const { caption, className = '', id, language1Caption, questionId, questionType, testId } = props;
	const { dispatch, state } = useContext(AppContext);
	const { language, riskq } = state;
	const checked = riskq.some(x => id === x.choiceId && questionId === x.questionId && testId === x.testId);
	const isCheckbox = QuestionType.CheckboxList === questionType;
	const TagName = isCheckbox ? Checkbox : Radio;

	const onChange = (isChecked: unknown) => {
		const payload = { riskq: [buildAnswer(testId, questionId, id)] };
		if (isCheckbox) {
			dispatch([isChecked ? addAnswer : removeAnswer, payload]);
		} else {
			dispatch([removeAnswers, payload]);
			dispatch([addAnswer, payload]);
		}
	};

	return (
		<div className={cn('choice', className)}>
			<TagName
				checked={checked}
				id={id.toString()}
				label={QuestionLabel(language.language, caption, language1Caption)}
				name={questionId.toString()}
				onChange={onChange}
			/>
		</div>
	);
}
